<div class="wrapper" [class.test-env-color]="useTestColor", [class.prod-env-color]="!useTestColor">
  <!-- Sidebar  -->
  <nav id="sidebar" [class.active]="navbarOpen">
    <div class="sidebar-header">
      <h3><i class="fa fa-ticket-alt"></i>Voucher Admin</h3>
    </div>

    <ul class="list-unstyled components">
      <li class="active">
        @if (enableCreateVoucher) {
          <div>
            <a routerLink="add-cs-voucher"><i class="fas fa-window-maximize"></i> Create Voucher</a>
          </div>
        }
        <div>
          <a routerLink="add-marketing-vouchers"><i class="fas fa-window-maximize"></i> Add Promotional Vouchers</a>
          <a routerLink="void-voucher"><i class="fas fa-window-maximize"></i> Void Voucher</a>
          <a routerLink="list-vouchers"><i class="fas fa-window-maximize"></i> All Vouchers</a>
        </div>
      </li>
    </ul>
  </nav>

  <div id="content-wrapper">
    <nav class="navbar navbar-expand-lg navbar-light bg-light mb-0" [class.display-none]="isPageNotFound">
      <div class="container-fluid">
        <button type="button" id="sidebarCollapse" class="btn btn-light" (click)="toggleNavbar()">
          <i class="fas fa-align-left"></i>
          <span>{{ navbarOpen === true ? ' Show Menu' : " Hide Menu"}}</span>
        </button>
      </div>
    </nav>

    <!-- Page Content  -->
    <div id="content">
      @if (!isIframe) {
        <router-outlet></router-outlet>
      }
    </div>
  </div>
</div>
